/****************************************************
 * Module Name:  invoicePaymentModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Constants from "../../utility/constants";
import { Box, TextField, Button } from "@mui/material";
import TabMenuSnackbar from "../common/tabMenuSnackbar";
import Utility from "../../utility/utility";
import logo from '../../images/pansuriya.jpg'
import { LoadingButton } from "@mui/lab";
import { FaMoneyBill } from "react-icons/fa6";

function InvoicePaymentModal({
    show,
    setShow,
    loader,
    handleValidation,
    handleSave,
    finalamount,
    invoiceid,
    currency
}) {
    const [amount, setAmount] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [showError, setShowError] = useState(false);

    const saveHandler = () => {
        let data = {
            id: invoiceid,
            amount: parseFloat(amount)
        }
        if (handleSave) {
            if (handleValidation) {
                if (handleValidation(data)) {
                    //need to add labId here and in the parent component if need for validation
                    handleSave(data);
                } else {
                    setShowError(true);
                }
            } else {
                handleSave(data);
            }
        }
    };

    const closeErrorDialog = () => {
        setShowError(false);
    };

    return (
        <div>
            <TabMenuSnackbar
                show={showError}
                message={
                    <Box>
                        Invoice Payment received validation Failed
                        <br /> Please enter correct data
                    </Box>
                }
                variant={"error"}
                autoHide={false}
                handleClose={closeErrorDialog}
                title="Validation Failure"
            />
            <Modal
                show={show}
                onHide={setShow}
                backdrop="static"
                keyboard={true}
                size="lg"
                centered
                enforceFocus={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <img
                            src={logo}
                            height="40pt"
                            width="40pt"
                            alt={Constants.COMPANY_SITE}
                        />
                        &nbsp;&nbsp;Amount to pay
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Box>
                        Payable Amount ({currency}) : {Utility.ConvertNumberWithSpecifiedDigits(finalamount)}
                    </Box>
                    <Box sx={{ display: "flex", gap: "20px", mt: 2 }}>
                        <Form.Label className="mt-2">Amount</Form.Label>
                        <TextField
                            id="outlined-multiline-static"
                            label="Enter Amount"
                            fullWidth
                            value={amount}
                            type="number"
                            inputMode="decimal"
                            helperText={errorMsg}
                            error={errorMsg.length > 0}
                            onChange={(e) => {
                                setAmount(e.target.value)
                                setErrorMsg(Utility.CheckisNumberNegative(
                                    e.target.value
                                ) || (e.target.value > finalamount)
                                    ? "Amount should be positive and not more than payable amount"
                                    : "")
                            }
                            }
                        />
                    </Box>
                </Modal.Body>
                <Modal.Footer>
                    <LoadingButton
                        loading={loader}
                        loadingPosition="start"
                        startIcon={<FaMoneyBill style={{ width: '20px', height: '20px' }} />}
                        variant="contained"
                        onClick={saveHandler}
                        type="Submit"
                        sx={{ mr: 3 }}
                        disabled={!amount || errorMsg.length > 0}
                    >
                        Pay
                    </LoadingButton>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={setShow}
                        sx={{ mr: 2 }}
                    >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default InvoicePaymentModal;
